// Count-up animation for stats blocks (templates/_blocks/_contentMatrix/_statsBlock.twig).
// The final value is already in the markup; this animates from 0 the first time it scrolls into view.
(function() {
    var DURATION = 1600;

    function format(value, decimals) {
        return value.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
    }

    function animate(el) {
        var target = parseFloat(el.getAttribute('data-value')) || 0;
        var decimals = parseInt(el.getAttribute('data-decimals'), 10) || 0;
        var output = el.querySelector('.stat-value');
        var start = null;

        function step(timestamp) {
            if (start === null) {
                start = timestamp;
            }
            var progress = Math.min((timestamp - start) / DURATION, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            output.textContent = format(target * eased, decimals);
            if (progress < 1) {
                requestAnimationFrame(step);
            } else {
                output.textContent = format(target, decimals);
            }
        }
        output.textContent = format(0, decimals);
        requestAnimationFrame(step);
    }

    document.addEventListener('DOMContentLoaded', function() {
        var counters = document.querySelectorAll('[data-stat-counter]');
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!counters.length || reduceMotion || !('IntersectionObserver' in window)) {
            return;
        }
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    observer.unobserve(entry.target);
                    animate(entry.target);
                }
            });
        }, { threshold: 0.5 });
        counters.forEach(function(counter) {
            observer.observe(counter);
        });
    });
})();
